import { put, takeEvery, call } from "redux-saga/effects";
import * as actionTypes from "./constants";
// import { appConfig } from "../../config";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import endpoints from "../endpoints";
// import api from "../api";
import fmApi from "../APIWrapper";

// function* commonGetFunction(value) {
//   const token = localStorage.getItem("fmsToken");
//   try {
//     const res = yield fetch(`${value.api}`, {
//       method: `${value.method}`,
//       headers: {
//         Accept: "application/json",
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${token}`,
//         type: "Web",
//       },
//       body: value.body ? value.body : null,
//     });
//     if (!res.ok) {
//       throw res;
//     } else {
//       const resJSON = yield res.json();

//       yield put({
//         type: `${value.sucessAction}`,
//         payload: resJSON,
//       });
//       yield put({ type: `${value.initAction}` });

//       yield toast.success(value.toastMsg, {
//         autoClose: 3000,
//       });

//       return resJSON;
//     }
//   } catch (err) {
//     if (err.ok === false) {
//       yield put({ type: `${value.failAction}`, error: err });
//     } else {
//     }
//   }
// }

function* addrwaMemberData() {}

function* fetchInvoiePayment() {
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  let data = {
    societyId: `${fmsUser.society_id}`,
  };
  try {
    // let params = {
    //   api: `${appConfig.urlPrefixIp}/societydataservice/society/invoice`,
    //   method: "POST",
    //   sucessAction: actionTypes.FETCH_INVOICEPAYMENTDATA_SUCCESS_ACTION,
    //   failAction: actionTypes.FETCH_INVOICEPAYMENTDATA_FAIL_ACTION,
    //   body: JSON.stringify(data),
    // };
    // const Res = yield call(api.commonGetFunction, params);
    // return Res;
    const resJSON = yield call(fmApi.FetchInvoiceApi, data);
    yield put({
      type: actionTypes.FETCH_INVOICEPAYMENTDATA_SUCCESS_ACTION,
      payload: resJSON,
    });
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.FETCH_INVOICEPAYMENTDATA_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

function* fetchInvoiePaymentDetails(value) {
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  // let data = {
  //   societyId: `${fmsUser.society_id}`,
  //   invCycleId: value?.value,
  // };
  try {
    // let params = {
    //   api: `${appConfig.urlPrefixIp}/billingservice/society/ledger`,
    //   method: "POST",
    //   sucessAction: actionTypes.FETCH_INVOICEPAYMENTDETAILS_SUCCESS_ACTION,
    //   failAction: actionTypes.FETCH_INVOICEPAYMENTDETAILS_FAIL_ACTION,
    //   body: JSON.stringify(data),
    // };
    // const Res = yield call(api.commonGetFunction, params);
    // if (Res?.response_data?.[0]?.channel !== "ONLINE") {
    //   yield put({
    //     type: actionTypes.FETCH_INVOICEPAYMENTCHECKDETAILS_INIT_ACTION,
    //     value: value,
    //   });
    // }
    // return Res;
    const resJSON = yield call(fmApi.FetchInvoiceLedgerApi, value);
    yield put({
      type: actionTypes.FETCH_INVOICEPAYMENTDETAILS_SUCCESS_ACTION,
      payload: resJSON,
    });
    // if (resJSON?.response_data?.[0]?.channel !== "ONLINE") {
    //   yield put({
    //     type: actionTypes.FETCH_INVOICEPAYMENTCHECKDETAILS_INIT_ACTION,
    //     value: value,
    //   });
    // }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.FETCH_INVOICEPAYMENTDETAILS_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

function* fetchInvoiePaymentCheckDetails(value) {
  let data = {
    invoice_cycle_id: value.value.value,
  };
  try {
    // let params = {
    //   api: `${appConfig.urlPrefixIp}/billingservice/society/invoicepayments`,
    //   method: "POST",
    //   sucessAction: actionTypes.FETCH_INVOICEPAYMENTCHECKDETAILS_SUCCESS_ACTION,
    //   failAction: actionTypes.FETCH_INVOICEPAYMENTCHECKDETAILS_FAIL_ACTION,
    //   body: JSON.stringify(data),
    // };
    // const Res = yield call(api.commonGetFunction, params);
    // return Res;
    const resJSON = yield call(fmApi.FetchInvoicePaymentsApi, data);
    yield put({
      type: actionTypes.FETCH_INVOICEPAYMENTCHECKDETAILS_SUCCESS_ACTION,
      payload: resJSON,
    });
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.FETCH_INVOICEPAYMENTCHECKDETAILS_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

function* addInvPayment(values) {
  const socId = JSON.parse(localStorage.getItem("FmsUser")).society_id;
  const username = JSON.parse(localStorage.getItem("FmsUser")).username;
  const token = localStorage.getItem("fmsToken");
  let data = {};
  data =
    values?.value?.type === "neft"
      ? {
          societyId: socId,
          username: username,
          type: values?.value?.type === "neft" ? "NEFT" : "",
          paymentDate: values?.value?.values?.paymentdate || "",
          amount: values?.value?.values?.Amountneft || "",
          refId: values?.value?.values?.Referenceid || "",
          invoice_cycle_id: values?.value?.invoiceId || "",
        }
      : {
          username: username,
          societyId: socId,
          invoice_cycle_id: values?.value?.invoiceId || "",
          type: values?.value?.type === "cheque" ? "CHEQUE" : "",
          bankName: values?.value?.values?.bankname || "",
          branchName: values?.value?.values?.branchname || "",
          chequeNo: values?.value?.values?.Chequeno || "",
          issueDate: values?.value?.values?.Issuedate || "",
          dropDate: values?.value?.values?.Dropdate || "",
          paymentDate: values?.value?.values?.Dropdate || "",
          amount: values?.value?.values?.amount || "",
        };
  try {
    // const res = yield fetch(
    //   `${appConfig.urlPrefixIp}/billingservice/society/addinvpayment`,
    //   {
    //     method: "POST",
    //     headers: {
    //       "Content-Type": "application/json",
    //       Authorization: `Bearer ${token}`,
    //       type: "Web",
    //     },
    //     body: JSON.stringify(data),
    //   }
    // );
    // if (!res.ok) {
    //   try {
    //     yield res.json();
    //   } catch {}
    //   throw res;
    // } else {
    //   const resJSON = yield res.json();
    const resJSON = yield call(fmApi.PostInvoicePaymentsApi, data);

    yield put({
      type: actionTypes.ADD_INVOICE_PAYMENT_SUCCESS_ACTION,
      payload: resJSON,
    });
    yield toast.success("Payment uploaded successfully", {
      autoClose: 3000,
    });
    yield put({
      type: actionTypes.FETCH_INVOICEPAYMENTDETAILS_INIT_ACTION,
      value: values?.value?.invoiceId,
    });
    yield put({
      type: actionTypes.FETCH_INVOICEPAYMENTDATA_INIT_ACTION,
    });
    // }
  } catch (err) {
    if (err.ok === false) {
      if (err.status === 400) {
        yield toast.error(`${endpoints.status400}`, {
          autoClose: 3000,
        });
      } else if (err.status === 500) {
        yield toast.error(`${endpoints.status500}`, {
          autoClose: 3000,
        });
      } else {
      }
      yield put({
        type: actionTypes.ADD_INVOICE_PAYMENT_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

export function* invoiceActionWatcher() {
  yield takeEvery(actionTypes.ADD_RWAMEMBER_INIT_ACTION, addrwaMemberData);
  yield takeEvery(
    actionTypes.FETCH_INVOICEPAYMENTDATA_INIT_ACTION,
    fetchInvoiePayment
  );
  yield takeEvery(
    actionTypes.FETCH_INVOICEPAYMENTDETAILS_INIT_ACTION,
    fetchInvoiePaymentDetails
  );
  yield takeEvery(
    actionTypes.FETCH_INVOICEPAYMENTCHECKDETAILS_INIT_ACTION,
    fetchInvoiePaymentCheckDetails
  );
  yield takeEvery(actionTypes.ADD_INVOICE_PAYMENT_INIT_ACTION, addInvPayment);
}
